import { HttpErrorResponse } from '@angular/common/http'
import { createAction, props } from '@ngrx/store'
import { WithClientsResult } from '../../../features/linking-with-clients/models/with-clients-result.interface'
import { BasicResult } from '../../models/interfaces/basic-result.interface'
import { BasicSearchFields } from '../../models/interfaces/basic-search-fields.interface'

export const setWithClientsDisplayLayoutList = createAction('[f-linking-tool] Linking with clients - display layout: LIST')

export const setWithClientsDisplayLayoutGrid = createAction('[f-linking-tool] Linking with clients - display layout: GRID')

export const setWithClientsSearchFields = createAction(
   '[f-linking-tool] Linking with clients - SETTING search fields',
   props<{ searchFields: BasicSearchFields }>()
)

export const getWithClientsData = createAction('[f-linking-tool] Linking with clients - GETTING data', props<{ request: BasicSearchFields }>())

export const getWithClientsDataSuccess = createAction(
   '[f-linking-tool] Linking with clients - GETTING data SUCCESS',
   props<{ data: BasicResult<BasicSearchFields, WithClientsResult> }>()
)

export const getWithClientsDataFailure = createAction('[f-linking-tool] Linking with clients - GETTING data FAILURE', props<{ error: HttpErrorResponse }>())

export const markWithClientsDataAsProcessed = createAction('[f-linking-tool] Linking with clients - marking data as processed', props<{ id: number }>())

export const markWithClientsDataAsProcessedSuccess = createAction('[f-linking-tool] Linking with clients - marking data as processed SUCCESS')

export const markWithClientsDataAsProcessedFailure = createAction(
   '[f-linking-tool] Linking with clients - marking data as processed FAILED',
   props<{ error: HttpErrorResponse }>()
)

export const deleteWithClientsData = createAction('[f-linking-tool] Linking with clients - deleting item', props<{ id: number }>())

export const deleteWithClientsDataSuccess = createAction('[f-linking-tool] Linking with clients - deleting item SUCCESS')

export const deleteWithClientsDataFailure = createAction('[f-linking-tool] Linking with clients - deleting item FAILURE', props<{ error: HttpErrorResponse }>())

export const resetWithClientsState = createAction('[f-linking-tool] Linking with clients - RESET DATA')

export const getWithClientsDetailByID = createAction('[f-linking-tool] Linking with clients - GETTING data by ID', props<{ id: number }>())

export const getWithClientsDetailByIDSuccess = createAction(
   '[f-linking-tool] Linking with clients - GETTING data by ID SUCCESS',
   props<{ data: WithClientsResult }>()
)

export const getWithClientsDetailByIDFailure = createAction(
   '[f-linking-tool] Linking with clients - GETTING data by ID FAILURE',
   props<{ error: HttpErrorResponse }>()
)
